"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextAreaField = void 0;
const react_1 = __importDefault(require("react"));
const TextAreaField = ({ field, value, onChange, error, disabled }) => (react_1.default.createElement("div", { className: "field-group" },
    react_1.default.createElement("label", { className: "field-label", htmlFor: field.key },
        field.label,
        field.required && react_1.default.createElement("span", { className: "required" }, "*")),
    react_1.default.createElement("textarea", { id: field.key, className: `field-input${error ? ' error' : ''}`, name: field.key, rows: 3, value: value || '', onChange: (e) => onChange(field.key, e.target.value), placeholder: `Enter ${field.label.toLowerCase()}…`, disabled: disabled }),
    field.tooltip && react_1.default.createElement("div", { className: "field-hint" }, field.tooltip),
    error && react_1.default.createElement("div", { className: "field-error" }, error)));
exports.TextAreaField = TextAreaField;
